export const PocTypes = {
  Row: 'ROW',
  soil: 'Soil Type',
};
